import React, { useState } from 'react';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent/index';
import StatefulTextField from '../../components/StatefulTextField/index';
import StatefulButton from '../../components/StatefulButton/index';

export default function EnterPassword() {
  const [password, setPassword] = useState('');
  const [warning, setWarning] = useState('');
  const checkpassword = () => {
    if (!password) return setWarning('Password blank');
    const url = new URL(window.location.href);
    url.searchParams.set('password', password);
    window.location = url.href;
  }
  if (warning && password) setWarning('');
  return (
    <FullScreenVerticalCenterContent>
      <h1 style={{ marginBottom: '2rem' }}>Enter Password</h1>
      <StatefulTextField
        value={password}
        onChange={setPassword}
        type="password"
        style={{ minWidth: 120, maxWidth: '80%', width: 400 }}
        label={'Password'}
        onKeyDown={(e) => { if (e.key === 'Enter') { checkpassword(); } }}
      />
      <div style={{ margin: 40 }}>
        <StatefulButton
          onClick={checkpassword}
          text={'Submit'}
          warning={warning}
          state=""
        />
      </div>
    </FullScreenVerticalCenterContent>
  );
}